import React from 'react';
import styled from 'styled-components';

const Checkbox = ({ text, completed, onChange, onClick }) => {
  return (
    <StyledWrapper>
      <div className="cyberpunk-checkbox-container">
        <label className="cyber-checkbox">
          <input type="checkbox" id="cyber-toggle" onChange={onChange} readOnly={!onChange} checked={completed} onClick={onClick} />
          <span className="checkbox">
            <span className="check-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width={28} height={28} viewBox="0 0 24 24" fill="none" stroke="#00FFFF" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round"> <path d="M20 6 9 17l-5-5" /> </svg>
            </span>
          </span>
          <div className="glow-layer" />
          <div className="glitch-layer" />
          <div className="text">{text}</div>
        </label>  
      </div>
    </StyledWrapper>
  );
}

const StyledWrapper = styled.div`
  .cyberpunk-checkbox-container {
    position: relative;
    max-width: 90%;
  }

  .cyber-checkbox {
    position: relative;
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;
    gap: 1rem;
  }

  .cyber-checkbox input {
    opacity: 0;
    width:0;
    height: 0;
  }

  /* Base box — light mode, subtle gradient */
  .checkbox {
    position: relative;
    min-width: 50px;
    max-width: 50px;
    height: 50px;
    background: linear-gradient(135deg, #fff6f6, #f2f2f2);
    border: 2px solid #ff6b6b;
    border-radius: 8px;
    box-shadow:
      inset 2px 2px 4px rgba(0, 0, 0, 0.1),
      0 0 5px rgba(255, 0, 0, 0.1);
    transition: all 0.25s ease;
  }

  .check-icon {
    position: absolute;
    top: 60%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0);
    opacity: 0;
    transition: all 0.3s ease;
  }

  .label-text {
    margin-left: 10px;
    font-size: 18px;
    font-weight: bold;
    color: #333;
    transition: all 0.3s ease;
  }

  .glow-layer,
  .glitch-layer {
    display: none; /* remove glow and glitch for clean light theme */
  }

  /* Hover Effect */
  .cyber-checkbox:hover .checkbox {
    transform: scale(1.05);
    border-color: #ff3b3b;
    box-shadow: 0 0 10px rgba(255, 100, 100, 0.3);
  }

  .cyber-checkbox:hover .label-text {
    color: #555;
  }

  /* Checked State */
  .cyber-checkbox input:checked + .checkbox {
    background: linear-gradient(135deg, #d8ffd8, #f5fff5);
    border-color: #4caf50;
    box-shadow:
      inset 2px 2px 4px rgba(0, 0, 0, 0.1),
      0 0 10px rgba(76, 175, 80, 0.2);
  }

  .cyber-checkbox input:checked + .checkbox .check-icon {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }

  .cyber-checkbox input:checked ~ .label-text {
    color: #4caf50;
  }

  .text {
    color: #111;
    font-weight: bolder;
    font-size: large;
    transition:all 0.3s ease;
  }

  input:checked ~ .text {
    text-decoration: line-through;
    color: #999;
  }`;

export default Checkbox;
